var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMagnifyingGlassPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4697 10.4697C10.7626 10.1768 11.2374 10.1768 11.5303 10.4697L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L10.4697 11.5303C10.1768 11.2374 10.1768 10.7626 10.4697 10.4697Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85876 3.14124C8.00377 1.28625 4.99623 1.28625 3.14124 3.14124C1.28625 4.99623 1.28625 8.00377 3.14124 9.85876C4.99623 11.7137 8.00377 11.7137 9.85876 9.85876C11.7137 8.00377 11.7137 4.99623 9.85876 3.14124ZM10.9194 2.08058C8.47864 -0.360194 4.52136 -0.360194 2.08058 2.08058C-0.360194 4.52136 -0.360194 8.47864 2.08058 10.9194C4.52136 13.3602 8.47864 13.3602 10.9194 10.9194C13.3602 8.47864 13.3602 4.52136 10.9194 2.08058Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 6.5C3.25 6.08579 3.58579 5.75 4 5.75H9C9.41421 5.75 9.75 6.08579 9.75 6.5C9.75 6.91421 9.41421 7.25 9 7.25H4C3.58579 7.25 3.25 6.91421 3.25 6.5Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 3.25C6.91421 3.25 7.25 3.58579 7.25 4V9C7.25 9.41421 6.91421 9.75 6.5 9.75C6.08579 9.75 5.75 9.41421 5.75 9V4C5.75 3.58579 6.08579 3.25 6.5 3.25Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifyingGlassPlus);
export default __webpack_public_path__ + "static/media/icon-magnifying-glass-plus.350573c6e721ebf04575f0aee174d06d.svg";
export { ForwardRef as ReactComponent };